// src/Components/Loader.js
import React from "react";
import { Grid } from "ldrs/react";
import "ldrs/react/Grid.css";
import Orb from "./Orb";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="orb-container">
        {/* Orb as background */}
        <Orb
          hoverIntensity={0}
          rotateOnHover={true}
          hue={1}
          forceHoverState={false}
        />
        {/* Grid centered on Orb */}
        <div className="grid-loader-container">
          <Grid size="120" speed="2" color="#6e1b9b" />
        </div>
      </div>
    </div>
  );
};
export default Loader;
